import { SettingsMenuEnum } from 'modules/profile/enums/settings-menu-enum'

export const settingsMenuHref: Record<SettingsMenuEnum, string> = {
  [SettingsMenuEnum.profile]: '/profile/user-settings',
  [SettingsMenuEnum.account]: '/profile/account-settings',
  [SettingsMenuEnum.my_plan]: '/profile/user-plan',
  [SettingsMenuEnum.payment_gateways]: '/profile/payment-gateways',
  [SettingsMenuEnum.manage_subscriptions]: '/profile/manage-subscriptions',
  [SettingsMenuEnum.mailing]: '/profile/mailing-settings',
  [SettingsMenuEnum.membership]: '/profile/course-settings',
  [SettingsMenuEnum.payment_page]: '/profile/payment-settings',
  [SettingsMenuEnum.sales_funnel]: '/profile/sales-funnels-settings',
  [SettingsMenuEnum.shipping]: '/profile/shipping-settings',
  [SettingsMenuEnum.affiliate_program]: '/profile/affiliate-program-settings',
  [SettingsMenuEnum.custom_domains]: '/profile/custom-domains-settings',
  [SettingsMenuEnum.public_api]: '/profile/public-api-settings',
  [SettingsMenuEnum.webhooks]: '/profile/webhook-settings',
  [SettingsMenuEnum.integrations]: '/profile/integrations',
  [SettingsMenuEnum.affiliate_commissions]: '/profile/affiliate-settings',
  [SettingsMenuEnum.notification]: '/profile/notification-settings',
  [SettingsMenuEnum.workspace_members]: '/profile/workspace-members',
  [SettingsMenuEnum.change_password]: '/profile/change-password',
}
